import React, { useEffect, useState } from "react";
import Spinner from "./Spinner";

import { API_BASE_URL } from "../config";

const TickerTape = ({ onTickerClick }) => {
    const [tickers, setTickers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        fetch(`${API_BASE_URL}/api/top-tickers`)
            .then((res) => res.json())
            .then((data) => {
                setTickers(data);
                setLoading(false);
            })
            .catch((err) => {
                console.error("Failed to fetch tickers:", err);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="ticker-tape-container" style={{ justifyContent: 'center', gap: '10px' }}>
                <Spinner />
                <span style={{ color: '#8fa1c7', fontSize: '0.9em' }}>Syncing market data...</span>
            </div>
        );
    }

    if (!tickers.length) return null;

    return (
        <div className="ticker-tape-container">
            <div className="ticker-tape">
                {tickers.map((t, i) => (
                    <div
                        key={i}
                        className="ticker-item clickable"
                        onClick={() => onTickerClick && onTickerClick(t.ticker)}
                        title="Click to load dashboard"
                    >
                        <span className="ticker-symbol">{t.ticker}</span>
                        <span className="ticker-assets">{t.assets}</span>
                        <span className="ticker-label"> {t.label || "Assets"}</span>
                    </div>
                ))}
                {/* Duplicate for seamless scrolling */}
                {tickers.map((t, i) => (
                    <div
                        key={`dup-${i}`}
                        className="ticker-item clickable"
                        onClick={() => onTickerClick && onTickerClick(t.ticker)}
                        title="Click to load dashboard"
                    >
                        <span className="ticker-symbol">{t.ticker}</span>
                        <span className="ticker-assets">{t.assets}</span>
                        <span className="ticker-label"> {t.label || "Assets"}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TickerTape;
